import axios from "axios";
import config from "app/api/axiosConfig";
import { IUserDTO } from "app/api/types";

export default (token: string, data: IUserDTO) =>
  axios.put(
    `${process.env.REACT_APP_API_HOST}/admin/users`,
    data,
    config(token)
  );
